import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { TituloReceber } from '../../../titulo-receber';
import { ConfigServerService, CustomHttp } from '../../../../../core';
import { TituloReceberIntegracaoImportFilter } from '../../titulo-receber-integracao-import-filter';

@Injectable({
    providedIn: 'root'
})
export class TituloReceberIntegracaoErpImportHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegrationErp()}/tituloreceber`;
    }

    /** Realiza a importação dos títulos a receber através da integração com o ERP */
    importMany(filter: TituloReceberIntegracaoImportFilter): Observable<TituloReceber[]> {
        return this.customHttp.post<TituloReceber[]>(`${this.pathApi}/0/import/many`, filter);
    }

    /* Realiza a importação do título a receber informado através da integração com o ERP **/
    importOne(idTituloReceber: number): Observable<TituloReceber> {
        return this.customHttp.get<TituloReceber>(`${this.pathApi}/${idTituloReceber}/import/one`);
    }
}
